<app-avatar *ngIf="user" [initial]="user.first_name?.charAt(0) || user.name?.charAt(0) || '?'" [size]="size"></app-avatar>